import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import cn from "classnames";
import logoImage from "../../assets/img/logo/logo.svg";
import $ from "jquery";
import { handleClickScroll } from "../../lib/helpers";
import { useLanguage } from "../../context/LanguageContext";

const HeaderOne = () => {
  const { currentLanguage, changeLanguage, t } = useLanguage();

  // active link switching
  const { hash, pathname } = useLocation();
  const isActiveLink = (id) => {
    // Check if we're on home page and the hash matches the section
    if (pathname === "/" && hash === `#${id}`) {
      return "active";
    }
    return "";
  };

  // sticky nav bar
  const [stickyClass, setStickyClass] = useState({
    fixed: "",
    header: "",
  });

  // track current active section
  const [activeSection, setActiveSection] = useState("");

  const stickNavbar = () => {
    if (window !== undefined) {
      let windowHeight = window.scrollY;
      // window height changed for the demo
      windowHeight < 245
        ? setStickyClass({ fixed: "", header: "" })
        : setStickyClass({ fixed: "active-height", header: "sticky-menu" });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", stickNavbar);
    return () => window.removeEventListener("scroll", stickNavbar);
  }, []);

  // Handle scrolling to section when landing on home page with anchor
  useEffect(() => {
    if (pathname === "/" && hash) {
      const sectionId = hash.substring(1);
      setActiveSection(sectionId);
      // Small delay to ensure the page is fully loaded
      setTimeout(() => {
        handleClickScroll(sectionId);
      }, 100);
    } else if (pathname === "/event") {
      // Clear active section when on event page
      setActiveSection("");
    }
  }, [hash, pathname]);

  // mobile menu
  useEffect(() => {
    //Menu Toggle Btn
    $(".mobile-nav-toggler").on("click", function () {
      $("body").addClass("mobile-menu-visible");
    });

    //Menu Toggle Btn
    $(".menu-backdrop, .mobile-menu .close-btn").on("click", function () {
      $("body").removeClass("mobile-menu-visible");
    });
  }, []);

  const handleLanguageChange = (language) => {
    changeLanguage(language);
  };

  const handleNavigationClick = (sectionId) => {
    // Set the active section
    setActiveSection(sectionId);

    // Check if we're on the home page
    if (pathname === "/") {
      // If on home page, just scroll to the section
      handleClickScroll(sectionId);
    } else {
      // If on other pages (like event page), navigate to home page with anchor
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <header id="header">
      <div id="header-fixed-height" className={cn(stickyClass.fixed)} />

      <div id="sticky-header" className={cn("menu-area", stickyClass.header)}>
        <div className={cn("container custom-container")}>
          <div className="row">
            <div className="col-12">
              <div className={"mobile-nav-toggler"}>
                <i className="fas fa-bars" />
              </div>

              <div className="menu-wrap">
                <nav className={"menu-nav"}>
                  <div className="logo" style={{ marginLeft: "15px" }}>
                    <Link to="/" onClick={() => handleClickScroll("header")}>
                      <img
                        src={logoImage}
                        alt="Realiste Logo"
                        width="150"
                        height="60"
                      />
                    </Link>
                  </div>

                  <div className={cn("navbar-wrap main-menu d-none d-lg-flex")}>
                    <ul className={"navigation"}>
                      <li
                        className={cn(
                          activeSection === "why-choose-us" && "active"
                        )}
                      >
                        <Link
                          to="/#why-choose-us"
                          className={"section-link"}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("why-choose-us");
                          }}
                        >
                          {t("navigation.whyChooseUs")}
                        </Link>
                      </li>
                      <li
                        className={cn(
                          activeSection === "market-growth" && "active"
                        )}
                      >
                        <Link
                          to="/#market-growth"
                          className={"section-link"}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("market-growth");
                          }}
                        >
                          {t("navigation.marketGrowth")}
                        </Link>
                      </li>
                      <li
                        className={cn(
                          activeSection === "megaprojects" && "active"
                        )}
                      >
                        <Link
                          to="/#megaprojects"
                          className={"section-link"}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("megaprojects");
                          }}
                        >
                          {t("navigation.megaprojects")}
                        </Link>
                      </li>
                      <li
                        className={cn(
                          activeSection === "dubai-vs-budapest" && "active"
                        )}
                      >
                        <Link
                          to="/#dubai-vs-budapest"
                          className={"section-link"}
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("dubai-vs-budapest");
                          }}
                        >
                          {t("navigation.dubaiVsBudapest")}
                        </Link>
                      </li>
                      <li className={cn(pathname == "/event" && "active")}>
                        <Link to="/event" className={"section-link"}>
                          {t("navigation.ourEvent")}
                        </Link>
                      </li>
                      {/* <li className={"menu-item-has-children"}>
                        <Link to="/blog">Blog</Link>
                        <ul className={cn("sub-menu")}>
                          <li className={cn(pathname == "/blog" && "active")}>
                            <Link to="/blog">Blogunk</Link>
                          </li>
                          <li
                            className={cn(
                              pathname == "/blog-details" && "active"
                            )}
                          >
                            <Link to="/blog-details">Blog részletek</Link>
                          </li>
                        </ul>
                      </li> */}
                      {/* <li className={isActiveLink("#contact")}>
                        <Link
                          to="#contact"
                          className={"section-link"}
                          onClick={() => handleClickScroll("contact")}
                        >
                          Kapcsolat
                        </Link>
                      </li> */}
                    </ul>
                  </div>
                  <div className={cn("header-action", "d-none d-md-block")}>
                    <ul>
                      <li className={"header-lang"}>
                        <span className={"selected-lang"}>
                          {currentLanguage.toUpperCase()}
                        </span>
                        <ul className={"lang-list"}>
                          <li>
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleLanguageChange("hu");
                              }}
                              className={
                                currentLanguage === "hu" ? "active" : ""
                              }
                            >
                              HUN
                            </Link>
                          </li>
                          <li>
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleLanguageChange("en");
                              }}
                              className={
                                currentLanguage === "en" ? "active" : ""
                              }
                            >
                              ENG
                            </Link>
                          </li>
                          {/* <li>
                            <Link to="#">ITA</Link>
                          </li> */}
                        </ul>
                      </li>
                      <li className={"header-btn"}>
                        <Link
                          to="/#contact"
                          className="btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("contact");
                          }}
                        >
                          {t("navigation.startInvestment")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>

              {/* <!-- Mobile Menu  --> */}
              <div className={"mobile-menu"}>
                <nav className={"menu-box"}>
                  <div className={"close-btn"}>
                    <i className="fas fa-times"></i>
                  </div>
                  <div className={"nav-logo"}>
                    <Link to="/">
                      <img
                        src={logoImage}
                        alt="Realiste Logo"
                        title="Realiste Logo"
                      />
                    </Link>
                  </div>

                  <div className={"menu-outer"}>
                    <ul className="navigation">
                      <li
                        className={cn(
                          activeSection === "why-choose-us" && "active"
                        )}
                      >
                        <Link
                          to="/#why-choose-us"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("why-choose-us");
                            $("body").removeClass("mobile-menu-visible");
                          }}
                        >
                          {t("navigation.whyChooseUs")}
                        </Link>
                      </li>
                      <li
                        className={cn(
                          activeSection === "market-growth" && "active"
                        )}
                      >
                        <Link
                          to="/#market-growth"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("market-growth");
                            $("body").removeClass("mobile-menu-visible");
                          }}
                        >
                          {t("navigation.marketGrowth")}
                        </Link>
                      </li>
                      <li
                        className={cn(
                          activeSection === "megaprojects" && "active"
                        )}
                      >
                        <Link
                          to="/#megaprojects"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("megaprojects");
                            $("body").removeClass("mobile-menu-visible");
                          }}
                        >
                          {t("navigation.megaprojects")}
                        </Link>
                      </li>
                      <li
                        className={cn(
                          activeSection === "dubai-vs-budapest" && "active"
                        )}
                      >
                        <Link
                          to="/#dubai-vs-budapest"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("dubai-vs-budapest");
                            $("body").removeClass("mobile-menu-visible");
                          }}
                        >
                          {t("navigation.dubaiVsBudapest")}
                        </Link>
                      </li>
                      <li className={cn(pathname == "/event" && "active")}>
                        <Link
                          to="/event"
                          onClick={() => {
                            $("body").removeClass("mobile-menu-visible");
                          }}
                        >
                          {t("navigation.ourEvent")}
                        </Link>
                      </li>
                      <li className={isActiveLink("#contact")}>
                        <Link
                          to="/#contact"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNavigationClick("contact");
                            $("body").removeClass("mobile-menu-visible");
                          }}
                        >
                          {t("navigation.startInvestment")}
                        </Link>
                      </li>
                    </ul>
                  </div>

                  {/* Mobile Language Selector */}
                  <div className="mobile-language-selector">
                    <div className="lang-title">
                      {t("languageSelector.title")}
                    </div>
                    <div className="lang-buttons">
                      <button
                        onClick={() => handleLanguageChange("hu")}
                        className={currentLanguage === "hu" ? "active" : ""}
                      >
                        Magyar
                      </button>
                      <button
                        onClick={() => handleLanguageChange("en")}
                        className={currentLanguage === "en" ? "active" : ""}
                      >
                        English
                      </button>
                    </div>
                  </div>

                  <div className={"social-links"}>
                    <ul className="clearfix">
                      <li>
                        <a
                          href="https://www.facebook.com/profile.php?id=61580254145406"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/realiste_hungary/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="fab fa-tiktok"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>

              <div className={"menu-backdrop"} />
              {/* <!-- End Mobile Menu --> */}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderOne;
